<ng-container>
  <ion-segment
    scrollable
    mode="md"
    [(ngModel)]="selectedMainGroup"
    *ngIf="mainGroups && (mainGroups | keyvalue).length > 0"
  >
    <ion-segment-button
      id="main-{{ i }}"
      [value]="mainGroup.value.groups"
      *ngFor="let mainGroup of mainGroups | keyvalue; let i = index"
    >
      <ion-label>{{ mainGroup.value.name | caption | translate }}</ion-label>
    </ion-segment-button>
  </ion-segment>

  <ion-list *ngIf="!isLimited || isSelected; else personCount">
    <ng-container
      *ngFor="let group of selectedMainGroup || catalogs; let k = index"
    >
      <ng-container
        *ngIf="
          dataServ.menuItem.menu_item_catalog_groups[k].menu_item_catalogs &&
          dataServ.menuItem.menu_item_catalog_groups[k].menu_item_catalogs
            .length > 0
        "
      >
        <ion-card
          class="accordion"
          [class.has-image]="dataServ.rData.id === 704 && group.images && group.images.length > 0"
          [class.no-image]="dataServ.rData.id === 704 && (!group.images || group.images.length === 0)"
          (click)="showMore[k] = !showMore[k]"
          appInView
          [data]="dataServ.menuItem.menu_item_catalog_groups"
          [showData]="catalogs"
          [index]="k"
          [style.background-image]="dataServ.rData.id === 704 && group.images && group.images.length > 0 ? 'url(' + group.images[0].url + ')' : 'none'"
        >
          <div class="accordion-overlay" *ngIf="dataServ.rData.id === 704 && group.images && group.images.length > 0"></div>
          <div class="accordion-content">
            <b>
              <ion-label
                [innerHtml]="group.name | caption | translate"
              ></ion-label>
            </b>
            <div class="se-time {{ group.is_closed ? 'red' : 'green' }}">
              <ng-container *ngIf="group.service_start_time">
                ({{ group.service_start_time }} - {{ group.service_end_time }})
              </ng-container>
              <ion-icon
                size="large"
                name="chevron-{{ showMore[k] ? 'up' : 'down' }}"
              ></ion-icon>
            </div>
          </div>
        </ion-card>

        <ng-container *ngIf="showMore[k]">
          <ng-container *ngFor="let catalog of group.menu_item_catalogs">
            <ng-container *ngIf="catalog">
              <ion-card *ngFor="let size of catalog.menu_item_catalog_prices">
                <ion-grid>
                  <ion-row>
                    <ion-col
                      [size]="
                        catalog.images && catalog.images.length > 0 ? '8' : '12'
                      "
                    >
                      <ion-label
                        class="name"
                        text-wrap
                        (click)="openCatalogItemDetail(catalog, size)"
                      >
                        <b>
                          <span
                            [innerHtml]="
                              (catalog.name | caption | translate) +
                              ((size.size | caption | translate)
                                ? ' (' + (size.size | caption | translate) + ')'
                                : '')
                            "
                          ></span>
                        </b>
                      </ion-label>

                      <ion-label class="name">
                        <ion-text color="medium">
                          <ng-container
                            *ngIf="
                              (catalog.description | caption | translate)
                                .length > 80;
                              else normal
                            "
                          >
                            <span
                              [innerHtml]="
                                catalog.description
                                  | caption
                                  | translate
                                  | slice : 0 : 80
                              "
                            ></span>
                            ...
                          </ng-container>
                          <ng-template #normal>
                            <span
                              [innerHtml]="
                                catalog.description | caption | translate
                              "
                            ></span>
                          </ng-template>
                        </ion-text>
                      </ion-label>

                      <ion-label
                        class="name"
                        (click)="openCatalogItemDetail(catalog, size)"
                      >
                        <ion-text color="primary">
                          <h6 class="see-details">
                            {{ "See Details" | translate }}...
                          </h6>
                        </ion-text>
                      </ion-label>

                      <!-- SİZE -->
                      <ng-container *ngIf="dataServ.menuItem.show_price">
                        <ng-container
                          *ngIf="
                            size.activate_offer &&
                              dataServ.rData.discount_for_only_member;
                            else cond2
                          "
                        >
                          <ng-container *ngIf="authServ.isLogged; else noOffer">
                            <ion-text color="success">
                              <ng-container
                                *ngIf="
                                  size.currency_code === 'TL';
                                  else otherLang
                                "
                              >
                                <ion-text color="medium">
                                  <s
                                    >{{ size.price | customCurrency }}
                                    {{ size.currency_code }}</s
                                  >
                                </ion-text>
                                <b
                                  >{{ size.offer_price | customCurrency }}
                                  {{ size.currency_code }}</b
                                >
                              </ng-container>
                              <ng-template #otherLang>
                                <ion-text color="medium">
                                  <s
                                    >{{ size.currency_code
                                    }}{{ size.price | customCurrency }}</s
                                  >
                                </ion-text>
                                <b>
                                  {{ size.currency_code
                                  }}{{ size.offer_price | customCurrency }}</b
                                >
                              </ng-template>
                            </ion-text>
                          </ng-container>
                        </ng-container>
                      </ng-container>

                      <ng-template #cond2>
                        <ng-container
                          *ngIf="
                            !size.activate_offer &&
                              dataServ.rData.general_discount_percentage;
                            else noOffer
                          "
                        >
                          <ng-container *ngIf="authServ.isLogged; else noOffer">
                            <ion-text color="success">
                              <ng-container
                                *ngIf="
                                  size.currency_code === 'TL';
                                  else otherLang
                                "
                              >
                                <ion-text color="medium">
                                  <s
                                    >{{ size.price | customCurrency }}
                                    {{ size.currency_code }}</s
                                  >
                                </ion-text>
                                <b>
                                  {{
                                    size.price -
                                      (size.price *
                                        dataServ.rData
                                          .general_discount_percentage) /
                                        100 | customCurrency
                                  }}{{ size.currency_code }}</b
                                >
                              </ng-container>
                              <ng-template #otherLang>
                                <ion-text color="medium">
                                  <s
                                    >{{ size.currency_code
                                    }}{{ size.price | customCurrency }}</s
                                  >
                                </ion-text>
                                <b>
                                  {{ size.currency_code
                                  }}{{
                                    size.price -
                                      (size.price *
                                        dataServ.rData
                                          .general_discount_percentage) /
                                        100 | customCurrency
                                  }}</b
                                >
                              </ng-template>
                            </ion-text>
                          </ng-container>
                        </ng-container>
                      </ng-template>

                      <ng-template #noOffer>
                        <ion-text color="primary" *ngIf="size.price > 0">
                          <ng-container
                            *ngIf="size.currency_code === 'TL'; else otherLang"
                          >
                            <b
                              >{{ size.price | customCurrency }}
                              {{ size.currency_code }}</b
                            >
                          </ng-container>
                          <ng-template #otherLang>
                            <ion-text color="primary">
                              <b
                                >{{ size.currency_code
                                }}{{ size.price | customCurrency }}</b
                              >
                            </ion-text>
                          </ng-template>
                        </ion-text>
                      </ng-template>

                      <ion-buttons
                        class="{{ group.is_closed ? 'disabled' : '' }}"
                        *ngIf="
                          dataServ.menuItem.order_system &&
                          dataServ.requestActive &&
                          catalog.images.length === 0
                        "
                      >
                        <ion-button
                          appEqualWidthHeight
                          equalWith="height"
                          [disabled]="size.quantity === 0"
                          fill="solid"
                          color="primary"
                          class="ion-no-padding"
                          (click)="
                            analytic(catalog, size, 'remove');
                            size.quantity = size.quantity - 1;
                            cartUpdate(catalog, size);
                            groupCounters[group.id] =
                              groupCounters[group.id] - 1
                          "
                        >
                          <ion-icon slot="icon-only" name="remove"></ion-icon>
                        </ion-button>

                        <ion-text color="primary">
                          <b *ngIf="!processing">{{
                            getCartItemById(size)
                              ? getCartItemById(size).size.quantity
                              : "0"
                          }}</b>
                        </ion-text>
                        <ion-button
                          appEqualWidthHeight
                          equalWith="height"
                          fill="solid"
                          color="primary"
                          class="ion-no-padding"
                          [disabled]="
                            group.max_per_person &&
                            group.max_per_person > 0 &&
                            group.max_per_person * cartServ.cover <=
                              groupCounters[group.id]
                          "
                          (click)="
                            analytic(catalog, size, 'add');
                            size.quantity = size.quantity + 1;
                            cartUpdate(catalog, size);
                            groupCounters[group.id]
                              ? (groupCounters[group.id] =
                                  groupCounters[group.id] + 1)
                              : (groupCounters[group.id] = 1)
                          "
                        >
                          <ion-icon slot="icon-only" name="add"></ion-icon>
                        </ion-button>
                      </ion-buttons>
                    </ion-col>

                    <ion-col
                      class="img-col"
                      size="4"
                      *ngIf="catalog.images && catalog.images.length > 0"
                    >
                      <ion-img
                        class="mb-2"
                        [src]="catalog.images[0].url"
                        (click)="openCatalogItemDetail(catalog, size)"
                      >
                      </ion-img>

                      <ion-buttons
                        *ngIf="
                          dataServ.menuItem.order_system &&
                          dataServ.requestActive
                        "
                        class="{{ group.is_closed ? 'disabled' : '' }}"
                      >
                        <ion-button
                          appEqualWidthHeight
                          equalWith="height"
                          [disabled]="size.quantity === 0"
                          fill="solid"
                          color="primary"
                          class="ion-no-padding"
                          (click)="
                            analytic(catalog, size, 'remove');
                            size.quantity = size.quantity - 1;
                            cartUpdate(catalog, size);
                            groupCounters[group.id] =
                              groupCounters[group.id] - 1
                          "
                        >
                          <ion-icon slot="icon-only" name="remove"></ion-icon>
                        </ion-button>

                        <ion-text color="primary">
                          <b *ngIf="!processing">{{ size.quantity }}</b>
                        </ion-text>

                        <ion-button
                          appEqualWidthHeight
                          equalWith="height"
                          fill="solid"
                          color="primary"
                          class="ion-no-padding"
                          [disabled]="
                            group.max_per_person &&
                            group.max_per_person > 0 &&
                            group.max_per_person * cartServ.cover <=
                              groupCounters[group.id]
                          "
                          (click)="
                            analytic(catalog, size, 'add');
                            size.quantity = size.quantity + 1;
                            cartUpdate(catalog, size);
                            groupCounters[group.id]
                              ? (groupCounters[group.id] =
                                  groupCounters[group.id] + 1)
                              : (groupCounters[group.id] = 1)
                          "
                        >
                          <ion-icon slot="icon-only" name="add"></ion-icon>
                        </ion-button>
                      </ion-buttons>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ion-list>

  <ng-template #personCount>
    <ion-text color="primary" class="ion-text-center">
      <h1>
        <b>{{ "Body Count" | translate }}</b>
      </h1>
    </ion-text>

    <ion-buttons class="person-buttons">
      <ion-button
        appEqualWidthHeight
        equalWith="height"
        [disabled]="cartServ.cover === 0"
        fill="solid"
        color="primary"
        class="ion-no-padding"
        (click)="cartServ.cover = cartServ.cover - 1"
      >
        <ion-icon slot="icon-only" name="remove"></ion-icon>
      </ion-button>

      <ion-text color="primary">
        <h1 class="ion-no-margin">
          <b *ngIf="!processing">{{ cartServ.cover }}</b>
        </h1>
      </ion-text>

      <ion-button
        appEqualWidthHeight
        equalWith="height"
        fill="solid"
        color="primary"
        class="ion-no-padding"
        (click)="cartServ.cover = cartServ.cover + 1"
      >
        <ion-icon slot="icon-only" name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
    <br />
    <ion-button (click)="isSelected = true" expand="block" class="next-button">
      {{ "Next" | translate }}
    </ion-button>
  </ng-template>
</ng-container>
